import { api } from '../client';
import type { AuditEvent, AuditSearchParams } from '@/types/audit';

/*
 * The audit trail. Read-only and paged: the filtering happens on the server,
 * because the trail is never shipped to the browser whole.
 */

export const auditApi = {
  list: (params: AuditSearchParams = {}) => api.getPage<AuditEvent>('/audit-events', { params }),
};
